"use strict";
import { RSAEncrypt } from "@ym-framework/rsa-encrypt";
export default class RSAEncryptUtil {
  constructor() {
    const key = "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtN51ugc1ifWSe3QU5vNy2uXpJEfzhTie8K3N947ZjYLjP0/7OD8Tr66B+i1rLz9TXDQxmjkONGHcG8zaDObmPAxHFTRA7okvd6CcrgYQ+mOh0XLDcGubh4MOBnmvlDRIz0JH9qXo5AnzTsfFDV8MPPr4RCFZNP+yHCnrNCsutWg39sX2NJNK8Y70OaMlUDrtCPXq3YBDgNe8f2/D0lZuba8zfQ16vUnkECjqGW/iqN2esqYkqWT5y3MZeZDzpQ7mEWC4Q6hT34TE1DecNF7dGXsH3yYtpuaQr805sktVMYUNMJlVbS2NNhjPVjZqoUxIO/GVlCshB1x+dFqkKs8q3wIDAQAB-----END PUBLIC KEY-----";
    this.rsaUtil = new RSAEncrypt(key);
  }
  encrypt(data) {
    try {
      const str = JSON.stringify(data);
      return {
        flag: true,
        data: this.rsaUtil.encrypt(str)
      };
    } catch (error) {
      return {
        flag: false,
        data
      };
    }
  }
}
